import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_coins_changes} from "../_signals/s_char";
import {ICharLPChanges} from "../_interfaces/ICharLPChanges";
import {ICharCoinChanges} from "../_interfaces/ICharCoinChanges";

export const CoinChangesGet = (cid: string) => {
    fetch(apiAddress + "/char/coinchanges/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                console.log('LCoinhanges get', data);
                if (data.hasOwnProperty('result')) {
                    s_char_coins_changes.value = (data.result as ICharLPChanges[])
                }
            }
        )
}

export const CoinChangesCreate = (coinchanges: ICharCoinChanges) => {
    fetch(apiAddress + "/char/coinchanges/", createOptions('CREATE', coinchanges))
        .then((res) => res.json())
        .then((data) => console.log('CoinChanges create', data))
        .catch((reason => console.log('CoinChanges create catch', reason)))
}

export const CoinChangesUpdate = (coinchanges: ICharCoinChanges) => {
    fetch(apiAddress + "/char/coinchanges/", createOptions('UPDATE', coinchanges))
        .then((res) => res.json())
        .then((data) => console.log('CoinChanges update', data))
        .catch((reason => console.log('CoinChanges create catch', reason)))
}